module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-MongoDB-Related-Packages-1024x878.0d0e95be.png";